/** Central Plaza — Website Lead (matches index.html gtag_report_conversion send_to). */
export const GOOGLE_ADS_CONVERSION_SEND_TO = "AW-18394748963/2xqxCPvaj6gdEKOwpsNE";

/** Fire after a successful POST /leads/website. Uses global gtag from index.html. */
export function reportGoogleAdsLeadConversion() {
  if (typeof window.gtag_report_conversion === "function") {
    window.gtag_report_conversion();
    return;
  }
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: GOOGLE_ADS_CONVERSION_SEND_TO });
}
